// Next Button
export const NEXT_BUTTON_DISABLED = 'You must select a crop box first';
export const NEXT_BUTTON_ENABLED = 'Click here to identify the selected font!';

// Crop Button
export const CROP_BUTTON = `Click and drag on your image to draw a crop box.
                            Be sure to only draw it around only one line of text.`;

// Rotate Buttons
export const ROTATE_BUTTON = 'Does this image need to be rotated? WhatTheFont will only work with horizontal text.';
export const ROTATE_90_LEFT = 'Rotate 90º left';
export const ROTATE_10_LEFT = 'Rotate 10º left';
export const ROTATE_90_RIGHT = 'Rotate 90º right';
export const ROTATE_10_RIGHT = 'Rotate 10º right';



// WEBPACK FOOTER //
// ./src/components/common/CropToolbar/CropToolbarTooltips.js